import { createAction, props } from '@ngrx/store';
import { CreateMemberDto, CreateRomTargetDto, MemberDto, TriageMemberDto, UpdateMemberDto } from '@shared/dto';

export const MEMBER_ACTIONS_TYPE = '@app/members';

// Read list
export const readMembers = createAction(`${MEMBER_ACTIONS_TYPE}/read`, props<{ sub: number; deleted?: boolean }>());
export const readMembersSuccess = createAction(`${MEMBER_ACTIONS_TYPE}/read/success`, props<{ data: MemberDto[] }>());
export const readMembersFailure = createAction(`${MEMBER_ACTIONS_TYPE}/read/failure`, props<{ error: any }>());

// Read single (detail) — resolves from the loaded list by id, falling back to a
// server fetch (readOne) so a reload/deep-link always has the full, fresh detail.
export const readMember = createAction(`${MEMBER_ACTIONS_TYPE}/read-one`, props<{ memberId: number }>());
export const readMemberSuccess = createAction(`${MEMBER_ACTIONS_TYPE}/read-one/success`, props<{ member: MemberDto }>());
export const readMemberFailure = createAction(`${MEMBER_ACTIONS_TYPE}/read-one/failure`, props<{ error: any }>());

// Create
export const createMember = createAction(`${MEMBER_ACTIONS_TYPE}/create`, props<{ sub: number; dto: CreateMemberDto }>());
export const createMemberSuccess = createAction(`${MEMBER_ACTIONS_TYPE}/create/success`, props<{ member: MemberDto }>());
export const createMemberFailure = createAction(`${MEMBER_ACTIONS_TYPE}/create/failure`, props<{ error: any }>());

/**
 * First Save carries `dto` and calls triage(). A retry after that member
 * exists carries `memberId` and must not call triage() again. `romTargets`
 * is optional on both: an empty wizard step has nothing to write.
 */
export type CreateTriageMemberPayload =
  | {
      sub: number;
      mode: 'create';
      dto: TriageMemberDto;
      romTargets?: CreateRomTargetDto[];
    }
  | {
      sub: number;
      mode: 'retry';
      memberId: number;
      romTargets?: CreateRomTargetDto[];
    };

export const createTriageMember = createAction(
  `${MEMBER_ACTIONS_TYPE}/triage`,
  (payload: CreateTriageMemberPayload) => payload,
);
export const createTriageMemberSuccess = createAction(`${MEMBER_ACTIONS_TYPE}/triage/success`, props<{ member: MemberDto }>());
export const createTriageMemberFailure = createAction(`${MEMBER_ACTIONS_TYPE}/triage/failure`, props<{
  error: any;
  member?: MemberDto;
}>());

// Update
export const updateMember = createAction(`${MEMBER_ACTIONS_TYPE}/update`, props<{ sub: number; memberId: number; dto: UpdateMemberDto }>());
export const updateMemberSuccess = createAction(`${MEMBER_ACTIONS_TYPE}/update/success`, props<{ member: Partial<MemberDto> }>());
export const updateMemberFailure = createAction(`${MEMBER_ACTIONS_TYPE}/update/failure`, props<{
  error: any;
  memberId: number;
}>());

// Delete
export const deleteMember = createAction(`${MEMBER_ACTIONS_TYPE}/delete`, props<{ sub: number; memberId: number }>());
export const deleteMemberSuccess = createAction(`${MEMBER_ACTIONS_TYPE}/delete/success`, props<{ member: MemberDto }>());
export const deleteMemberFailure = createAction(`${MEMBER_ACTIONS_TYPE}/delete/failure`, props<{
  error: any;
  memberId: number;
}>());

// Restore
export const restoreMember = createAction(`${MEMBER_ACTIONS_TYPE}/restore`, props<{ sub: number; memberId: number }>());
export const restoreMemberSuccess = createAction(`${MEMBER_ACTIONS_TYPE}/restore/success`, props<{ member: MemberDto }>());
export const restoreMemberFailure = createAction(`${MEMBER_ACTIONS_TYPE}/restore/failure`, props<{
  error: any;
  memberId: number;
}>());
